<script setup lang="ts" generic="T, TFull">
import type { Props } from 'nuxt-base/components/BaseImage.vue'
import type { RouteLocationRaw } from '#vue-router'

const t2 = useT2({
  'View all': 'Žiūrėti viską',
})

type FullUi = { title: string | None; image: Props['img']; documentId: string | None; slugMath: string }

const props = defineProps<{
  title: stringI18n
  slug: string | None
  full: TFull | None
  back: RouteLocationRaw | undefined
  fullui(full: TFull): FullUi
  items: T[] | None
  ui(i: T): { id: string; image: Props['img']; title: string | None; to: RouteLocationRaw | undefined }
}>()

const data = shallowReactive({
  renderList: [] as string[],
  doc: undefined as undefined | FullUi,
})

// const timer = useTimeout()

watch(
  (): FullUi | undefined => {
    const { slug, full } = props
    const doc = slug && full ? props.fullui(full) : undefined
    return !doc || doc?.slugMath !== slug ? undefined : doc
  },
  (cur) => {
    const prevSlug = data.doc?.slugMath
    if (cur) {
      data.doc = cur
      const currSlug = cur.slugMath
      const list = data.renderList
      if (!list.includes(currSlug)) data.renderList = [...list, currSlug]
    }

    if (import.meta.client && cur && cur.slugMath !== prevSlug) {
      // timer.set(() => utilsScrollTop(), 100)
    }
  },
  { immediate: true }
)

const arr = computed(() => {
  const toUi = props.ui
  return helpers.arr(props.items, (org) => ({ org, ui: toUi(org) }))
})

const ui222 = computed(() => {
  const list = data.renderList
  const slug = props.slug

  return arr.value.map((item) => {
    const render = list.includes(item.ui.id)
    return {
      item,
      calcs: {
        on: render && slug === item.ui.id,
        render,
      },
    }
  })
})

// https://www.everlane.com/factories/underwear
// https://www.sweatybetty.com/shop-finder
// https://www.endclothing.com/eu/stores
// https://www.meandem.com/stores
</script>

<template>
  <AppMenu :title="title" max>
    <div class="d_pl1 d_pr1">
      <div v-for="({ item, calcs }, index) in ui222" :key="item.ui.id" :class="$style.box2">
        <UiGrow :open="item.ui.id !== props.slug">
          <NuxtLink :class="$style.box" :to="item.ui.to">
            <div :class="$style.nr">{{ index + 1 }}</div>
            <BaseImage :img="item.ui.image" sizes="220px" class="_br14" ratio="square" />

            <div class="_col _pt1 d_pl2 m_pl1">
              <h2 v-if="item.ui.title" class="_pb1">{{ item.ui.title }}</h2>
              <slot v-bind="{ item: item.org }" />
            </div>
            <div :class="$style.link">
              <LinkUi :to="undefined" :txt="t2('View all')" arrow />
            </div>
          </NuxtLink>
        </UiGrow>

        <UiGrow v-if="calcs.render" :open="calcs.on">
          <div class="_relative">
            <ButtonIcon :class="[$style.close, 'IconArrow']" :txt="t2('Close')" :to="back" right><IconArrow left class="_svg16" /></ButtonIcon>
            <BaseImage v-if="data.doc?.image" :img="data.doc?.image" sizes="75vw" class-img="_w100p" ratio="16:9" />
            <div :class="$style.split">
              <h2 v-if="data.doc?.title" class="_fs34 _pt1 _pb4">{{ data.doc?.title }}</h2>
              <div v-if="$slots.full" :class="$style.splitC">
                <slot name="full" v-bind="{ item: full }" />
              </div>
              <DocumentUi :document-id="data.doc?.documentId" />
            </div>
          </div>
        </UiGrow>
      </div>
    </div>
  </AppMenu>
</template>

<style module>
.box2 {
  composes: global(_br22);
  composes: global(m_mr04);
  composes: global(m_ml04);
  composes: global(_b5);
  composes: global(_hidden);
  /* border-color: var(--black-3); */

  box-shadow: 0 0 0 1px var(--line);
  --line: transparent;
}

.box {
  composes: global(_relative);
  composes: global(_spaced);

  height: 200px;

  composes: global(_grid);
  grid-template-columns: 190px 1fr max-content;

  composes: global(_pt04);
  composes: global(_pb04);
  composes: global(_pl04);
  composes: global(_pr04);
}

:global(.m) .box {
  grid-template-columns: 1fr;
  height: auto;
}

.box:hover {
  --line: var(--black);
  box-shadow: 0 0 0 1px var(--black-5);
  border-radius: 14px;
}

.nr {
  composes: global(_absolute);
  composes: global(_ctr);

  composes: global(_fw-xl);
  composes: global(_fs08);

  composes: global(_svg24);

  composes: global(_br99);

  composes: global(_c1);

  top: 10px;
  left: 12px;

  background: #fff;
  z-index: 1;
}

.close {
  composes: global(_absolute);
  composes: global(_bg0);

  top: 10px;
  left: 10px;
  z-index: 1;
}

.split {
  composes: global(_col);
  composes: global(_pt2);
  composes: global(_pl2);
  composes: global(_pb140);
  composes: global(_start);
}
.link {
  composes: global(_row);
  composes: global(m_pt4);
  composes: global(m_pb1);
  composes: global(m_pl1);
  align-self: flex-end;
}
</style>
